module.exports = __webpack_public_path__ + "img/add-departure-requested-table-icon.21a4fc20.svg";